import React from 'react';

type AboutComponentProps = {
  children: JSX.Element;
};

function About({ children }: AboutComponentProps) {
  return <div className="about__route">{children}</div>;
}

export default About;
